import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import ApplicationForm from '../components/ApplicationForm';

const Application = () => {
  return (
    <Box sx={{ backgroundColor: 'background.default', minHeight: 'calc(100vh - 64px - 200px)', py: 4 }}>
      <Container maxWidth="lg">
        <Typography variant="h3" component="h1" gutterBottom color="primary.main" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 2 }}>
          Başvuru Merkezi
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ textAlign: 'center', mb: 4, maxWidth: '800px', mx: 'auto' }}>
          Altyapı sorunlarına son! Hemen başvurun, sizi dünyaya bağlayalım. Fişe takıp hemen kullanmaya başlayın.
        </Typography>
        <ApplicationForm />
      </Container>
    </Box>
  );
};

export default Application;
